import { useCallback } from "react";

/**
 * Shared hook for line items table handlers
 * Used in PurchaseOrderLineItemsTable and SubContractLineItemsTable
 */
export const useLineItemsTableHandlers = (
  rows,
  onRowsChange,
  onFormDataChange,
  defaultRowFields
) => {
  const handleEdit = useCallback(
    (rowId, field, value) => {
      const updatedRows = rows.map((row, idx) =>
        idx === rowId ? { ...row, [field]: value } : row
      );
      onRowsChange(updatedRows);
      onFormDataChange(updatedRows);
    },
    [rows, onRowsChange, onFormDataChange]
  );

  const handleAddRow = useCallback(() => {
    const newRow = { ...defaultRowFields };
    const updatedRows = [...rows, newRow];
    onRowsChange(updatedRows);
    onFormDataChange(updatedRows);
  }, [rows, onRowsChange, onFormDataChange, defaultRowFields]);

  const handleRemoveRow = useCallback(
    (rowId) => {
      const updatedRows = rows.filter((_, idx) => idx !== rowId);
      onRowsChange(updatedRows);
      onFormDataChange(updatedRows);
    },
    [rows, onRowsChange, onFormDataChange]
  );

  return { handleEdit, handleAddRow, handleRemoveRow };
};

/**
 * Shared function to create base data row with common fields
 */
export const createBaseDataRow = (row, idx, dropdownOptions, getDisplayText) => {
  const budgetCode = dropdownOptions?.budgetCodes?.find((b) => b.id === row.budgetCodeId);
  return {
    id: idx,
    rowNumber: idx + 1,
    changeEvent: row.changeEvent || "",
    budgetCodeId: row.budgetCodeId || "",
    description: row.description || "",
    amount: row.amount || "",
    billed: row.billed || "",
    remaining: row.remaining || "",
    budgetCode: getDisplayText(row.budgetCodeId, dropdownOptions?.budgetCodes, "budgetCode") || "",
    changeEventName:
      getDisplayText(row.changeEvent, dropdownOptions?.changeEvents, "changeEvent") || "",
    "Cost Code Tier 1": budgetCode?.cost_code_level_1 || row.cost_code_level_1 || "",
    "Cost Code Tier 2": budgetCode?.cost_code_level_2 || row.cost_code_level_2 || "",
    "Cost Type": budgetCode?.category || row.category || "",
  };
};
